export default "__VITE_ASSET__ChqB2HsO__"